import { AspectRatio } from "../../../../types";
import { DimensionsType } from "../../constants";
import { ASPECT_RATIO_MAP, SORTED_ASPECT_RATIO_TYPES } from "./constants";
import { PresetType } from "./types";

export const getPresetFromAspectRatio = (
  aspectRatio: AspectRatio,
): PresetType => ({
  ...ASPECT_RATIO_MAP[aspectRatio.type],
  dimensions: [aspectRatio.width, aspectRatio.height],
});

export const getPresetsFromAspectRatios = (
  aspectRatios: AspectRatio[],
): PresetType[] =>
  [...aspectRatios]
    .sort(
      (a, b) =>
        SORTED_ASPECT_RATIO_TYPES.indexOf(a.type) -
        SORTED_ASPECT_RATIO_TYPES.indexOf(b.type),
    )
    .map(getPresetFromAspectRatio);

export const getAreDimensionsEqual = (
  dimensions1: DimensionsType,
  dimensions2: DimensionsType,
) => dimensions1[0] === dimensions2[0] && dimensions1[1] === dimensions2[1];

export const getAreAspectRatiosEqual = (
  dimensions1: DimensionsType,
  dimensions2: DimensionsType,
) => dimensions1[0] / dimensions1[1] === dimensions2[0] / dimensions2[1];
